// extracted by mini-css-extract-plugin
export default {"loader":"sJJ0f","rotate-ltr":"_2AB8u","rotateLtr":"_2AB8u","rotate-rtl":"cKoKm","rotateRtl":"cKoKm"};